import { GET_TYPE_REST } from "../actions/typeRest.actions";

const initialState = {};

export default function typeRestReducer(state = initialState, action) {
  switch (action.type) {
    case GET_TYPE_REST:
      return action.payload;
    default:
      return state;
  }
}
